var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t4-wrap"},[_c('span',{staticClass:"elementor-screen-only",attrs:{"id":"elementor-device-mode","aria-hidden":"true"}}),_c('HomeType4Content',{attrs:{"homeInfo":_vm.homeInfo,"expertConfig":_vm.expertConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }